import React, {
  createContext, useContext, useState, useMemo,
} from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

const PopupContext = createContext({});

function PopupProvider({ children }) {
  const [popup, setPopup] = useState(null);

  const openPopup = (popup) => setPopup(popup);

  const closePopup = (callback) => {
    if (typeof callback === 'function') { callback(); }
    setPopup(null);
  };

  const value = useMemo(() => ({ popup, openPopup, closePopup }), [popup]);

  return (
    <PopupContext.Provider value={value}>
      {children}
    </PopupContext.Provider>
  );
}

export const usePopup = () => useContext(PopupContext);

export default (props) => <ComponentErrorBoundary><PopupProvider {...props} /></ComponentErrorBoundary>;
